// extracted by mini-css-extract-plugin
export default {"section":"LearningPath_section__mTy1N","title":"LearningPath_title__1pggL"};